import {createAsyncThunk, createEntityAdapter, createSlice} from '@reduxjs/toolkit';
import { getIeOrderApi, reCreateIEOrderApi } from '../../../services/ieOrder';

export const getIeOrder = createAsyncThunk('order/ieOrder', async (data, {dispatch}) => {
    const response = await getIeOrderApi(data);
    dispatch(setIEOrderTableRowCount(response.response.count));
    return response.response.data;
});

export const reCreateIEOrder = createAsyncThunk('order/reCreateIEOrder', async (data, {dispatch}) => {
    const response = await reCreateIEOrderApi(data);
    return response.response;
});

const ieOrderAdapter = createEntityAdapter({});
export const {selectAll: selectIeOrders, selectById: ieOrderById} = ieOrderAdapter.getSelectors(
    state => state.order.ieOrder
);

const ieOrderSlice = createSlice({
    name: 'ieOrder',
    initialState: ieOrderAdapter.getInitialState({
        ieOrderTableRow: 0,
    }),
    reducers: {
        setIEOrderTableRowCount: (state, action) => {
            state.ieOrderTableRow = action.payload;
        },
    },
    extraReducers: {
        [getIeOrder.fulfilled]: ieOrderAdapter.setAll,
    }
});

export const {setIEOrderTableRowCount} = ieOrderSlice.actions;

export default ieOrderSlice.reducer;
